import { render, staticRenderFns } from "./CreateEventBankAccount.vue?vue&type=template&id=902b387c&scoped=true"
import script from "./CreateEventBankAccount.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEventBankAccount.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateEventBankAccount.vue?vue&type=style&index=0&id=902b387c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902b387c",
  null
  
)

export default component.exports